function FailPage (){
    return(
        <div>결제중 문제가 발생했습니다. 관리자에게 문의하세요</div>
    );
}


export default FailPage;